import { styled } from 'styled-components';
export const FullWidthLayout = styled.div.withConfig({
  displayName: "Playerstyles__FullWidthLayout",
  componentId: "sc-1diex68-0"
})(["width:100%;overflow:hidden;position:relative;"]);